import { Box, BoxProps, CircularProgress } from "@mui/material";

export interface LoaderProps extends Omit<BoxProps, "children"|"component">{
    size?:string|number
}

export default function Loader({
    position = "relative",
    size = "30px",
    ...props
}:LoaderProps){
    return <Box position={position} {...props}>
        <Box 
            position={"absolute"} top={0} bottom={0} left={0} right={0} 
            display={"flex"} alignItems={"center"} justifyContent={"center"}
            overflow={"clip"}
        >
            <CircularProgress size={size} color="info"/>
        </Box>
    </Box>
}